import useSWR from 'swr';
import { fetchIrrigation } from './irrigationService';
import { useIrrigationStore } from './irrigationStore';

export function useIrrigationTypes() {
	const { setIrrigation } = useIrrigationStore();

	return useSWR('irrigationTypes', fetchIrrigation, {
		revalidateOnFocus: false,
		revalidateOnReconnect: false,
		onSuccess: (irrigation) => {
			setIrrigation(irrigation);
		},
	});
}
